import React from 'react';

const statusToneClass = (tone) =>
  ['danger', 'warning', 'info', 'success'].includes(tone)
    ? `is-tone-${tone}`
    : 'is-tone-info';

export function FleetStatusFilterButton({
  active,
  icon,
  label,
  mobileLabel,
  value,
  helper,
  tone,
  onClick,
}) {
  const toneClass = statusToneClass(tone);
  const className = `customer-preview-status-card ${toneClass}${active ? ' is-active' : ''}`;

  return (
    <button type="button" className={className} onClick={onClick}>
      <span className="customer-preview-status-copy">
        <span className="customer-preview-status-label">
          <span className="customer-preview-status-label-full">{label}</span>
          <span className="customer-preview-status-label-mobile">{mobileLabel || label}</span>
        </span>
        <span className="customer-preview-status-value">{value}</span>
        <span className="customer-preview-status-helper">{helper}</span>
      </span>
      <span className="customer-preview-status-icon">{icon}</span>
    </button>
  );
}

export function MobileStatusFilterControl({ active, label, value, tone, onClick }) {
  const toneClass = statusToneClass(tone);
  const className = `customer-preview-mobile-status-filter ${toneClass}${
    active ? ' is-active' : ''
  }`;

  return (
    <button type="button" className={className} onClick={onClick}>
      <span className="customer-preview-mobile-status-filter-label">{label}</span>
      <span className="customer-preview-mobile-status-filter-value">{value}</span>
    </button>
  );
}
